module.exports = __webpack_public_path__ + "media/entities/5111-095336c3.png";